import axios from 'axios';
import api from './api';  // assuming there's an api.js for base URL and config

export const getdocumentlog = async (params) => {
  const response = await axios.post('/api/documentlog/query', {
    ...params,
  });

  console.log('Document Log Response:', response);
  return response.data;
};
